import { Injectable } from '@angular/core';
import {HttpClient, HttpHeaders} from "@angular/common/http";
import {AuthService} from "../auth/auth.service";
import {HandleError} from "../handle-error";
import {UrlsResources} from "../urls-resources";
import {Observable} from "rxjs/Observable";
import {GlottoCustomer} from "../customers/glotto-customer";

@Injectable()
export class UploadAwardsService {

  constructor(protected httpClient: HttpClient,
              private authService: AuthService,
              private handleError: HandleError,
              protected urlsResources: UrlsResources) { }


  uploadFile(formData): Observable<any> {
    const headers = new HttpHeaders({'Accept': 'application/json'});
    const httpOptions = {
      headers: headers,
      withCredentials: true
    };
    const url = this.urlsResources.uploadAwardsUrl();
    console.log(formData, 'formdata')
    return this.httpClient.post(url, formData, httpOptions)
      .map(response => { return response; });

  }

  getFilesUploaded(httpParams): Observable<Array<GlottoCustomer>> {
    const httpOptions = {
      withCredentials: true,
      params: httpParams,
    };

    return this.httpClient.get<Array<GlottoCustomer>>(this.urlsResources.awardsUploadedUrl(), httpOptions);
  }

}



// WEBPACK FOOTER //
// /codebuild/output/src14910448/src/src/app/core/upload-awards/upload-awards.service.ts